export async function geocodeAddress(
  query: string
): Promise<{ lat: number; lng: number } | null> {
  // 👉 Replace with your actual geocoding provider
  const token = import.meta.env.VITE_MAPBOX_TOKEN; // set this in .env
  if (!token) {
    console.error("Missing Mapbox token");
    return null;
  }

  const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(
    query
  )}.json?access_token=${token}&limit=1&country=ZA`;

  try {
    const res = await fetch(url);
    if (!res.ok) {
      console.error("Geocoding failed", res.statusText);
      return null;
    }
    const data = await res.json();
    const feature = data.features?.[0];
    if (!feature) return null;

    const [lng, lat] = feature.center;
    return { lat, lng };
  } catch (err) {
    console.error("Error geocoding:", err);
    return null;
  }
}
